import * as React from "react";

interface IProps {
  children: React.ReactNode;
}

function PageContainerWide({ children }: IProps) {
  return (
    <div className="container-fluid" style={{maxWidth:'none'}}>
      {children}
    </div>
  );
}

export default PageContainerWide;



// WEBPACK FOOTER //
// ./app/javascript/components/core/PageContainerWide.tsx